"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectDFP = exports.deviceFingerPrint = void 0;
const features_1 = require("./detectors/browser/features");
const formFields_1 = require("./detectors/browser/formFields");
const plugins_1 = require("./detectors/browser/plugins");
const user_agent_1 = require("./detectors/browser/user-agent");
const font_detector_1 = require("./detectors/fonts/font-detector");
const language_1 = require("./detectors/language");
const screen_1 = require("./detectors/screen");
const time_1 = require("./detectors/time");
const utils_1 = require("./utils/utils");
function deviceFingerPrint() {
    const responseTime = [];
    let t1, t2;
    const startTimeStamp = time_1.currentTimeStamp();
    const startTime = time_1.getTime();
    const devicePrint = {};
    t1 = time_1.getTime();
    devicePrint.userAgent = user_agent_1.browserUserAgent();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.timezone = time_1.collectTimeZoneInfo();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.screen = screen_1.browserScreen();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.language = language_1.browserLanguage();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.fonts = font_detector_1.browserFonts();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.plugins = plugins_1.browserPluginsOld();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.cookieEnabled = navigator.cookieEnabled ? 'true' : 'false';
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.javaEnabled = navigator.javaEnabled().toString();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.touchEnabled = features_1.touchEnabled();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.silverLight = plugins_1.silverLightDetails();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.flash = plugins_1.flashDetails();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    /**
     * Using async/await led to a drastic increase in overall execution
     * time for these scripts. This was especially true when we implemented the
     * native Crypto.subtle.digest in `generateChecksum` as opposed to the Sha256.hash
     * function in {@Link ./utils/sha.ts}.
     *
     * Additionally, async/await doesn't have native support in IE11.
     *
     **/
    // await canvasHash().then(a => {
    //   devicePrint.canvas = a;
    // });
    devicePrint.canvas = features_1.canvasHash();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    /**
     * 5/14/2021
     *
     * The below methods do not exist in the current production version of the
     * browser fingerprint. Leaving them here will cause a drastic increase in
     * challenge rates as the checksum values will change.
     *
     * They are commented out to allow for their future introduction into the BFP
     * generator in the easiest manner possible.
     *
     */
    // await webGLHash().then(a => {
    //   devicePrint.webGLHash = a;
    // });
    // devicePrint.webGLHash = webGLHash();
    // t2 = getTime();
    // responseTime.push(`${t2 - t1}`);
    // devicePrint.webGL = webGL();
    // t1 = getTime();
    // responseTime.push(`${t1 - t2}`);
    // devicePrint.audioFormats = audioFormats();
    // t2 = getTime();
    // responseTime.push(`${t2 - t1}`);
    // devicePrint.hardwareConcurrency = `${window.navigator.hardwareConcurrency}`;
    // t1 = getTime();
    // responseTime.push(`${t1 - t2}`);
    // /* eslint-disable @typescript-eslint/no-explicit-any */
    // devicePrint.deviceMemory = (navigator as any).deviceMemory
    //   ? `${(navigator as any).deviceMemory}`
    //   : '';
    // /*eslint-enable*/
    // t2 = getTime();
    // responseTime.push(`${t2 - t1}`);
    // devicePrint.storage = browserStorage();
    // t1 = getTime();
    // responseTime.push(`${t1 - t2}`);
    // devicePrint.touchSupport = touchSupport();
    // t2 = getTime();
    // responseTime.push(`${t2 - t1}`);
    // devicePrint.webDriver = navigator.webdriver ? navigator.webdriver : 'false';
    // t1 = getTime();
    // responseTime.push(`${t1 - t2}`);
    // devicePrint.doNotTrack = doNotTrack();
    // t2 = getTime();
    // responseTime.push(`${t2 - t1}`);
    // devicePrint.adBlock = adBlock();
    // t1 = getTime();
    // responseTime.push(`${t1 - t2}`);
    devicePrint.trueBrowser = user_agent_1.browserTrueAgent();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    const cstr = JSON.stringify(devicePrint);
    devicePrint.tcn = utils_1.tcn(startTimeStamp);
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.browser = user_agent_1.browserInfo();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.system = user_agent_1.browserSystemInfo();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.connectionInfo = features_1.browserConnectionInfo();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.latency = features_1.browserLatency();
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.formFields = formFields_1.browserFormFields();
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.version = '4.0.0';
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    devicePrint.timestamp = startTimeStamp;
    t2 = time_1.getTime();
    responseTime.push(`${t2 - t1}`);
    devicePrint.checksum = utils_1.generateChecksum(cstr);
    t1 = time_1.getTime();
    responseTime.push(`${t1 - t2}`);
    responseTime.push(`${t2 - startTime}`);
    devicePrint.rt = responseTime;
    return devicePrint;
}
exports.deviceFingerPrint = deviceFingerPrint;
function collectDFP() {
    const dfp = deviceFingerPrint();
    const encodedInput = btoa(JSON.stringify(dfp));
    const encodedOutput = encodeURIComponent(encodedInput)
        .replace(/~/g, '%7E')
        .replace(/!/g, '%21')
        .replace(/\*/g, '%2A')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/'/g, '%27')
        .replace(/-/g, '%2D')
        .replace(/_/g, '%5F')
        .replace(/\./g, '%2E');
    return encodedOutput;
}
exports.collectDFP = collectDFP;
//# sourceMappingURL=browser-fingerprint.js.map